import React from "react";
import { LavatoryProps } from "./types";

const Lavatory: React.FC<LavatoryProps> = () => {
  return (
    <div className="w-8 h-8 flex items-center justify-center lavatoryWrap">
      <img
        src="//jsak.mmtcdn.com/flights/assets/media/lavatory.png"
        alt="Lavatory"
        className="w-full h-full"
      />
    </div>
  );
};

export default Lavatory;
